import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const SOCIAL_ICONS = { Instagram, LinkedIn: Linkedin };

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="relative bg-black text-white border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6 items-start">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={`${process.env.PUBLIC_URL}/images/logo.png`}
                alt="Delta Pictures"
                className="w-10 h-10 object-contain"
                draggable="false"
              />
              <p className="font-display text-white text-2xl leading-none tracking-tight">
                Delta Pictures
              </p>
            </div>
            <p className="font-mono-eyebrow text-neutral-500">
              {t.footer.tagline} · 2009 / {year}
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono-eyebrow text-neutral-500 mb-5">{t.footer.offices}</p>
            <ul className="space-y-4 text-neutral-300 text-[15px]">
              <li>
                <p className="text-white">{t.footer.biella}</p>
                <p className="text-neutral-500 text-sm mt-1">Via Boglietti, 2 · 13900 Biella (IT)</p>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono-eyebrow text-neutral-500 mb-5">{t.footer.contacts}</p>
            <div className="mb-2">
              <a
                href="mailto:info@deltapictures.it"
                data-testid="footer-email"
                className="text-white text-[15px] link-underline"
              >
                info@deltapictures.it
              </a>
            </div>
            <div>
              <a href="tel:+390152471679" className="text-neutral-400 text-[15px] link-underline">
                +39 015 247 16 79
              </a>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 text-[12px] text-neutral-500">
          <div className="flex-1 max-w-4xl leading-relaxed">
            © Delta Pictures S.r.l. – Cap. Soc. € 50.000 i.v. – P. IVA: 02154000026 – n. R.E.A. BI 181760
          </div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-3">
            {t.footer.legalLinks.map((l) =>
              l.label === "Gestione Consenso Cookie" ? (
                <button
                  key={l.label}
                  type="button"
                  data-testid="footer-change-consent"
                  className="change-consent link-underline hover:text-white transition-colors"
                  onClick={() => {
                    if (typeof window.__tcfapi === "function") {
                      window.__tcfapi("displayConsentUi", 2, () => {});
                    } else {
                      window.location.href = "/cookie-policy";
                    }
                  }}
                >
                  {l.label}
                </button>
              ) : (
                <Link
                  key={l.label}
                  to={l.url}
                  className="link-underline hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              )
            )}
            <span className="text-neutral-700">|</span>
            {t.footer.social.map((s) => {
              const Icon = SOCIAL_ICONS[s.label];
              return (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="hover:text-white transition-colors"
                >
                  <Icon size={16} />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
}
